import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { socket } from 'api';
import { notify } from 'libs/common';
import { closeWindow } from 'store/actions/windows';
import { Window } from 'components/shared/window/window';
import { WrapMessage, Button, Buttons, Content } from './alert-enable.styled';

const enabled = false;

export const AlertEnable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const toggleFireAlert = () => {
    socket.call('racks.set_fire_alarm', { enable: !enabled });
    notify(t('windows.Пожарная тревога'), t('windows.Тревога включена'), 'danger');
    close();
  };

  const close = () => {
    dispatch(closeWindow('AlertConfirmModal'));
  };

  return (
    <Window header={t('windows.Пожарная тревога')} width="340px" id="AlertConfirmModal" closeWindow>
      <Content>
        <WrapMessage>
          <img src="/images/warning-icon.png" alt="" />
          <div>
            {t('windows.Все шлагбаумы будут открыты')}. {t('windows.Продолжить?')}
          </div>
        </WrapMessage>
        <Buttons>
          <Button onClick={toggleFireAlert}>{t('buttons.Подтвердить')}</Button>
          <Button onClick={close}>{t('buttons.Отмена')}</Button>
        </Buttons>
      </Content>
    </Window>
  );
};
